import { CADASTRAR_REPASSE_VENDA } from '../../actions/types'

const initialState = undefined
const estadoInicial = []

export default function reducerCadastroRepasseVenda (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case CADASTRAR_REPASSE_VENDA: {
        if(action.payload.data) {
            return action.payload.data
        }
      return []
    }

    default: {
      return state
    }
  }
}